import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedFlagsReducer(state = initialState.selectedFlags, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_FLAGS_SUCCESS:
      return action.selectedFlags;
    default:
      return state;
  }
}
